
import PrimaryButton from 'js/components/elements/PrimaryButton.vue';
import stealth from 'js/components/assignment/stealthMixin'
import redirect from 'js/components/assignment/redirectMixin'

export default {
    mixins: [ stealth, redirect ],
    props: [ 'assignment', 'steps', 'progress' ],
    components: { PrimaryButton },
    methods: {

        /**
         * Checks if a step is validated
         * i.e. the user viewed it and filled in all questions/uploads
         *
         * @param  {Step} step
         * @param  {Boolean} checkConfirm=true if this step should be confirmed, use this flag to skip the confirm check. False = skip confirm check
         * @return {Boolean} true if validated, false otherwise
         */
        validateStep: function(step, checkConfirm = true) {

            // if the previous step has not been completed, this step cannot be valid
            if ( this.progress.step < (step.precedence - 1) ) {
                return false
            }

            // if the step is frozen it must be validated
            if ( this.progress.frozen >= step.precedence ) {
                return true
            }

            // if step should be confirmed and it is not frozen, then it's not validated
            if ( step.confirm && checkConfirm && this.progress.frozen < step.precedence) {
                return false
            }

            // if this step has been completed, this step is valid
            if ( this.isStepCompleted(step) ) {
                return true
            }

            // check if all partials are validated
            const partials = step.partials.map( id => this.$store.state.partials.storage[id] )

            for ( var p of partials) {

                if ( p.validated !== true ) {
                    return false
                }

            }

            return true

        },


        isStepCompleted: function(step) {
            return this.progress.step >= step.precedence
        },



    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/assignment/stepMixin.js